// API utility for authenticated requests
// Handles both cookie-based auth (same-origin) and token-based auth (cross-origin/mobile)

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Storage key for the session token
const TOKEN_KEY = 'guapgoals_session_token';

// Save session token to localStorage
export const saveToken = (token) => {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  }
};

// Get session token from localStorage
export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

// Clear session token from localStorage
export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

// Make authenticated API request
// Automatically includes credentials (cookies) AND Authorization header (for mobile)
export const apiRequest = async (endpoint, options = {}) => {
  const token = getToken();
  
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };
  
  // Add Authorization header if we have a token
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  const response = await fetch(`${API}${endpoint}`, {
    ...options,
    headers,
    credentials: 'include', // Still include cookies for same-origin scenarios
  });
  
  return response;
};

// Convenience methods
export const apiGet = (endpoint, options = {}) => {
  return apiRequest(endpoint, { ...options, method: 'GET' });
};

export const apiPost = (endpoint, data, options = {}) => {
  return apiRequest(endpoint, {
    ...options,
    method: 'POST',
    body: JSON.stringify(data),
  });
};

export const apiPut = (endpoint, data, options = {}) => {
  return apiRequest(endpoint, {
    ...options,
    method: 'PUT',
    body: JSON.stringify(data),
  });
};

export const apiDelete = (endpoint, options = {}) => {
  return apiRequest(endpoint, { ...options, method: 'DELETE' });
};

export default {
  API,
  saveToken,
  getToken,
  clearToken,
  apiRequest,
  apiGet,
  apiPost,
  apiPut,
  apiDelete,
};
